import ReportBrandMagnetScoreAndProgression from './reportBrandMagnetScoreAndProgression'
export default ReportBrandMagnetScoreAndProgression
